// extracted by mini-css-extract-plugin
export default {"block":"quiz-picture_block__Eog7V","picture":"quiz-picture_picture__lv0Gk","media":"quiz-picture_media__c50dm","rotate":"quiz-picture_rotate__jhLmg"};